<template>
  <div id="app">
    <router-view/>
  </div>
 
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  height: 100%;
  background: var(--bg);
  color: var(--text);
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans CJK SC", "WenQuanYi Micro Hei", sans-serif;
}

:root {
  --bg: #0b0d10;
  --card: #0f1318;
  --card-2: #12171d;
  --muted: #9aa4ad;
  --text: #e8edf2;
  --primary: #5b86ff;
  --primary-press: #476ef0;
  --danger: #ff6b6b;
  --input: #161c23;
  --border: #212a33;
  --radius: 14px;
}

#app {
  min-height: 100vh;
}
</style>

